export const getLegendBarStyle = (barBounds, fullBounds) => {
  const [left, right] = barBounds
  const [fullLeft, fullRight] = fullBounds
  return {
    left: `${((left - fullLeft) / (fullRight - fullLeft)) * 100}%`,
    width: `${((right - left) / (fullRight - fullLeft)) * 100}%`,
  }
}
